import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { PATHS } from '../../utils/vars'

import styles from './LegalNav.module.scss'

const LegalNav = ({ selected }) => (
    <nav className={`${styles.legalPageNav} nav row`}>
        <div className={`col ${styles.col}`}>
            <Link href={PATHS.PRIVACY_POLICY}>
                <button type="button" className={`btn navBtn ${selected === PATHS.PRIVACY_POLICY ? ' selected' : ''}`}>
                    Privacy Policy
                </button>
            </Link>
        </div>
        <div className={`col ${styles.col}`}>
            <Link href={PATHS.TERMS_CONDITIONS}>
                <button type="button" className={`btn navBtn ${selected === PATHS.TERMS_CONDITIONS ? ' selected' : ''}`}>
                    Terms &amp; Conditions
                </button>
            </Link>
        </div>
        <div className={`col ${styles.col}`}>
            <Link href={PATHS.COOKIE_POLICY}>
                <button type="button" className={`btn navBtn ${selected === PATHS.COOKIE_POLICY ? ' selected' : ''}`}>
                    Cookie Policy
                </button>
            </Link>
        </div>
    </nav>
)

LegalNav.propTypes = {
    selected: PropTypes.string.isRequired,
}

export default LegalNav
